export default "__VITE_ASSET__BktZ56RX__"